import { createAsyncThunk } from '@reduxjs/toolkit';
import userService from '../../services/userService';
import { loginSuccess, loginFailure, setLoading, updateProfile as updateProfileAction } from './userSlice';

// Thunk to fetch user profile and update Redux
export const fetchUserProfile = createAsyncThunk(
  'user/fetchProfile',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      
      const result = await userService.getProfile();
      
      if (result.success) {
        dispatch(loginSuccess(result.data.user));
        return result.data.user;
      } else {
        dispatch(loginFailure(result.error));
        return rejectWithValue(result.error);
      }
    } catch (error) {
      dispatch(loginFailure(error.message));
      return rejectWithValue(error.message);
    }
  }
);

// Thunk to update user profile
export const updateUserProfile = createAsyncThunk(
  'user/updateProfile',
  async (profileData, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      
      const result = await userService.updateProfile(profileData);
      
      if (result.success) {
        dispatch(updateProfileAction(result.data.user));
        return result.data.user;
      } else {
        return rejectWithValue(result.error);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

// Thunk to check authentication status
export const checkAuthStatus = createAsyncThunk(
  'user/checkAuth',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await userService.checkAuth();
      
      if (result.success) {
        dispatch(loginSuccess(result.data.user));
        return result.data.user;
      } else {
        dispatch(loginFailure(result.error));
        return rejectWithValue(result.error);
      }
    } catch (error) {
      dispatch(loginFailure(error.message));
      return rejectWithValue(error.message);
    }
  }
);

// Thunk to change password
export const changeUserPassword = createAsyncThunk(
  'user/changePassword',
  async (passwordData, { rejectWithValue }) => {
    try {
      const result = await userService.changePassword(passwordData);
      
      if (result.success) {
        return result.message;
      } else {
        return rejectWithValue(result.error);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);